import { HabitFrequencyEnum } from "../../Types/Enums/HabitFrequencyEnum";

export const HABIT_FREQUENCY_MAP = [
  { id: HabitFrequencyEnum.ONCE_W, labels: { 0: "una vez a la semana", 1: "once a week" } },
  { id: HabitFrequencyEnum.TWICE_W, labels: { 0: "dos veces a la semana", 1: "twice a week" } },
  { id: HabitFrequencyEnum.THRICE_W, labels: { 0: "tres veces a la semana", 1: "thrice a week" } },
  { id: HabitFrequencyEnum.FOUR_W, labels: { 0: "cuatro veces a la semana", 1: "four times a week" } },
  { id: HabitFrequencyEnum.FIVE_W, labels: { 0: "cinco veces a la semana", 1: "five times a week" } },
  { id: HabitFrequencyEnum.SIX_W, labels: { 0: "seis veces a la semana", 1: "six times a week" } },
  { id: HabitFrequencyEnum.DAILY, labels: { 0: "diariamente", 1: "daily" } },

  { id: HabitFrequencyEnum.OCCASIONAL, labels: { 0: "ocasional", 1: "occasional" } },
  { id: HabitFrequencyEnum.WEEKLY, labels: { 0: "semanalmente", 1: "weekly" } },
  { id: HabitFrequencyEnum.MONTHLY, labels: { 0: "mensualmente", 1: "monthly" } },
  { id: HabitFrequencyEnum.ONCE, labels: { 0: "única vez", 1: "once" } },
  { id: HabitFrequencyEnum.RARELY, labels: { 0: "rara vez", 1: "rarely" } },
  { id: HabitFrequencyEnum.NEVER, labels: { 0: "nunca", 1: "never" } },

];

// Helper to filter options safely
const filterFrequencies = (keys) => HABIT_FREQUENCY_MAP.filter(item => keys.includes(item.id));


export const FITNESS_FREQUENCY_MAP = filterFrequencies([
  HabitFrequencyEnum.NEVER,
  HabitFrequencyEnum.RARELY,
  HabitFrequencyEnum.OCCASIONAL,
  HabitFrequencyEnum.ONCE_W,
  HabitFrequencyEnum.TWICE_W,
  HabitFrequencyEnum.THRICE_W,
  HabitFrequencyEnum.FOUR_W,
  HabitFrequencyEnum.FIVE_W,
  HabitFrequencyEnum.SIX_W,
  HabitFrequencyEnum.DAILY,
]);

export const JUNK_FOOD_FREQUENCY_MAP = filterFrequencies([
  HabitFrequencyEnum.NEVER,
  HabitFrequencyEnum.RARELY,
  HabitFrequencyEnum.OCCASIONAL,
  HabitFrequencyEnum.ONCE_W,
  HabitFrequencyEnum.TWICE_W,
  HabitFrequencyEnum.THRICE_W,
  HabitFrequencyEnum.FOUR_W,
  HabitFrequencyEnum.FIVE_W,
  HabitFrequencyEnum.SIX_W,
  HabitFrequencyEnum.DAILY,
  HabitFrequencyEnum.WEEKLY,
  HabitFrequencyEnum.MONTHLY,
]);


export const SUBSTANCE_FREQUENCY_MAP = filterFrequencies([
  HabitFrequencyEnum.OCCASIONAL,
  HabitFrequencyEnum.WEEKLY,
  HabitFrequencyEnum.DAILY,
  HabitFrequencyEnum.MONTHLY,
  HabitFrequencyEnum.ONCE,
]);